<template>
  <div>
    <div
      class="el-progress"
      :class="[
        'el-progress--' + type,
        status ? 'is-' + status : '',
        {
          'el-progress--without-text': !showText,
          'el-progress--text-inside': textInside,
        }
      ]"
      role="progressbar"
      :aria-valuenow="percentage1"
      aria-valuemin="0"
      aria-valuemax="100"
      :style="totalWidth"
    >
    <div class="el-progress-bar" v-if="type === 'line'" >
        <div class="el-progress-bar__outer" :style="{height: strokeWidth + 'px'}">
          <div class="el-progress-bar__inner" :style="barStyle1">
            <div class="el-progress-bar__innerText" v-if="showText && textInside">{{percentage1}}%</div>
          </div>
        </div>
      </div>
      <div class="el-progress-bar" v-if="type === 'line-double'"  :style="barStyle">
        <div class="el-progress-bar__outer" :style="{height: strokeWidth + 'px'}">
          <div class="el-progress-bar__inner" :style="barStyle2">
            <!--<div class="el-progress-bar__innerText" v-if="showText && textInside">{{percentage2}}%</div> -->
          </div>
          <div class="el-progress-bar__inner" :style="barStyle1">
            <!--<div class="el-progress-bar__innerText" v-if="showText && textInside">{{percentage1}}%</div>-->
          </div>
        </div>
      </div>
      <a class="text" >
        <!--<span v-if="this.value1 === this.targetValue" slot="reference">
          <i class="el-icon-circle-check" style="color: #69b42d " /> &nbsp;
        </span>
        <span :style="{ textDecoration: textSelected ? 'underline' : '' }">{{value1 | hoursMinutes }} </span>-->
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ProgressBar',
    props: {
      target: {
        type: Number,
        default: 0,
        required: true
      },
      value1: {
        type: Number,
        default: 0,
        required: true
      },
      value2: {
        type: Number,
        default: 0,
        required: true
      },
      strokeWidth: {
        type: Number,
        default: 18
      },
      type: {
        type: String,
        default: 'line'
      },
      textInside: {
        type: Boolean,
        default: true
      },
      width: {
        type: Number,
        default: 126
      },
      showText: {
        type: Boolean,
        default: true
      },
      color1: {
        type: String,
        default: ''
      },
      color2: {
        type: String,
        default: ''
      },
      text: {
        type: String,
        default: ''
      },
      status: {
        type:String,
        default: ''
      },
      unit: {
        type:String,
        default: ''
      },
      stepSize: {
        type: Number,
        default: 1
      },
      maxValue: {
        type: Number,
        default: 999999999
      },
      outerTextWidth: {
        type: Number,
        default: 70
      }
    },
    data() {
      return {
        textSelected: false,
        deltaVal: 0
      }
    },
    computed: {
      targetValue() {
        let newValue = this.target + this.deltaVal
        ////if (this.targetValue && newValue !== this.targetValue) {
          this.$emit('change', newValue)
        //}
        return newValue
      },
      percentage1() {
        return Math.min(100, (this.value1 / this.targetValue * 100).toFixed(0));
      },
      percentage2() {
        return Math.min(100, (this.value2 / this.targetValue * 100).toFixed(0));
      },
      barStyle1() {
        return {
          "width": this.percentage1 + '%',
          "background-color": this.color1,
        }
      },
      barStyle2() {
        return {
          "width": this.percentage2 + '%',
          "background-color": this.color2
        }
      },
      relativeStrokeWidth() {
        return (this.strokeWidth / this.width * 100).toFixed(1);
      },
      trackPath() {
        const radius = parseInt(50 - parseFloat(this.relativeStrokeWidth) / 2, 10);
        return `M 50 50 m 0 -${radius} a ${radius} ${radius} 0 1 1 0 ${radius * 2} a ${radius} ${radius} 0 1 1 0 -${radius * 2}`;
      },
      perimeter() {
        const radius = 50 - parseFloat(this.relativeStrokeWidth) / 2;
        return 2 * Math.PI * radius;
      },
      circlePathStyle() {
        const perimeter = this.perimeter;
        return {
          strokeDasharray: `${perimeter}px,${perimeter}px`,
          strokeDashoffset: (1 - this.percentage1 / 100) * perimeter + 'px',
          transition: 'stroke-dashoffset 0.6s ease 0s, stroke 0.6s ease'
        };
      },
      stroke() {
        let ret;
        if (this.color1) {
          ret = this.color1;
        } else {
          switch (this.status) {
            case 'success':
              ret = '#13ce66';
              break;
            case 'exception':
              ret = '#ff4949';
              break;
            default:
              ret = '#20a0ff';
          }
        }
        return ret;
      },
      iconClass() {
        if (this.percentage1 === 100) {
          return 'el-icon-circle-check'; //  : 'el-icon-circle-close'
        } else {
          return ''
        }
      },
      progressTextSize() {
        return this.type === 'line'
          ? 12 + this.strokeWidth * 0.4
          : this.width * 0.111111 + 2;
      },
      totalWidth() {
        return {
          'width': this.width + 'px'
        }
      },
      barStyle() {
        return {
          'float': 'left',
          'width': this.width - this.outerTextWidth + 'px'
        }
      },
      tooltipremainingTime() {
        return this.targetValue - this.value1 + " " + this.unit + " remaining"
      }
    },
    methods: {
      /*zoom(evt) {
        // console.log(evt)
        //const deltaX = event.evt.deltaX;
        //const deltaY = event.evt.deltaY;
        //console.log(deltaX, deltaY)
        if (evt.deltaY < 0) {
          // console.log(this.deltaVal, this.maxValue, this.stepSize)
          this.deltaVal = Math.min(this.maxValue - this.target,  this.deltaVal + 1 * this.stepSize);
        }
        if (evt.deltaY > 0) {
          // console.log(this.value1,  this.deltaVal, this.stepSize)
          this.deltaVal = Math.max(this.value1  - this.target,  this.deltaVal - 1 * this.stepSize);
        }
      },
      onMouseover() {
        this.textSelected = true
      },
      onMouseout() {
        this.textSelected = false
      }*/
    },
    mounted() {
      window.addEventListener('mouseup', this.stopDrag);
    }
  };
</script>

<style lang="scss">
.el-progress-bar {
  overflow: hidden;
  white-space: nowrap;
}

.text {
  display: inline-block;
  vertical-align: middle;
  color: #000;
  font-size: 12px;
  margin: 0 5px;
  float: right;
  line-height: 18px;
}

/*
.box {
  width: 400px;

  .right {
    float: right;
    width: 110px;
  }

  .item {
    margin: 4px;
  }

  .left .el-tooltip__popper,
  .right .el-tooltip__popper {
    padding: 8px 10px;
  }

  .el-button {
    width: 110px;
  }
}
*/
</style>
